import { Component, computed, inject, signal } from '@angular/core';
import { Router } from '@angular/router';
import { QrExternalBuildingDto, QrExternalService, QrSessionDto } from '@artemis-software/wr-api';
import { asyncComputed } from '@/utils/signals/asyncComputed';
import { loader } from '@/utils/signals/loader';
import { QrSessionService } from '@services/qr-session.service';
import { ContractorCredentialsService } from '@services/contractor-credentials.service';

@Component({
  standalone: false,
  selector: 'wr-qr-external-buildings-page',
  templateUrl: './qr-external-buildings-page.component.html',
  styleUrls: ['./qr-external-buildings-page.component.scss'],
})
export class QrExternalBuildingsPageComponent {
  private readonly router = inject(Router);
  private readonly credentialsService = inject(ContractorCredentialsService);
  private readonly qrExternalService = inject(QrExternalService);
  private readonly qrSessionService = inject(QrSessionService);

  readonly loading = loader();
  readonly search = signal('');
  readonly session = signal<QrSessionDto | undefined>(undefined);

  readonly buildings = asyncComputed(() => this.qrExternalService.findAllBuildings(), [], this.loading);

  readonly filteredBuildings = computed(() => {
    const term = this.search().trim().toLowerCase();
    const buildings = this.buildings() ?? [];
    if (!term) {
      return buildings;
    }
    return buildings.filter(building =>
      [building.name, building.internalNumber ?? '', building.sectionText]
        .some(value => value.toLowerCase().includes(term)),
    );
  });

  constructor() {
    this.qrSessionService.session().then(session => this.session.set(session));
  }

  openBuilding(building: QrExternalBuildingDto): void {
    const root = ['/building-qr', this.credentialsService.getCurrentShortCode() ?? ''];
    this.router.navigate(building.scanned ? root : [...root, 'building', building.id]);
  }
}
